import { css } from "@emotion/css";
import { ParseHelper } from "@octopusdeploy/design-system-octopus-components";
import { ControlType, type IIdName, type ProcessTemplateParameterResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { useState } from "react";
import { ProducerTemplatesParameterSelector } from "~/areas/platformHub/processEditor/ProducerTemplatesParameterSelector";
import { IconButtonWithTooltip } from "~/components/IconButtonWithTooltip/index";
import { TeamMultiSelect } from "~/components/MultiSelect/TeamMultiSelect";
import { isBoundRegex } from "~/components/form/BoundField/isBound";
import boundFieldStyles from "~/components/form/BoundField/style.module.less";
import type { FormFieldProps } from "~/components/form/index";
export interface ProcessTemplatesTeamParameterSelectProps extends FormFieldProps<string> {
    items: IIdName[];
    label?: string | JSX.Element;
    error?: string;
    onParameterAdded?: (parameters: ProcessTemplateParameterResource[]) => void;
}
export function ProcessTemplatesTeamParameterSelect({ items, label, value, error, onChange, onParameterAdded }: ProcessTemplatesTeamParameterSelectProps) {
    let parameterValue = "";
    let multiSelectValue: string[] = [];
    if (value) {
        if (isBoundRegex(value)) {
            parameterValue = value;
        }
        else {
            multiSelectValue = ParseHelper.parseCSV(value);
        }
    }
    const [isUsingParameter, setIsUsingParameter] = useState<boolean>(!!parameterValue);
    const toolTipContent = isUsingParameter ? "Set teams" : "Set parameter";
    return (<div className={boundFieldStyles.container}>
            <span className={styles.container}>
                {isUsingParameter ? (<ProducerTemplatesParameterSelector selectedParameter={parameterValue} onParameterChange={onChange} controlType={ControlType.Teams} allowClear={true} onParameterAdded={onParameterAdded}/>) : (<TeamMultiSelect label={label} items={items} value={multiSelectValue} error={error} onChange={(val) => onChange(ParseHelper.encodeCSV(val))}/>)}
            </span>

            <div className={boundFieldStyles.buttons}>
                <IconButtonWithTooltip onClick={() => {
            setIsUsingParameter(!isUsingParameter);
            if (value) {
                onChange("");
            }
        }} toolTipContent={toolTipContent} icon={isUsingParameter ? "LinkOffIcon" : "LinkOnIcon"} accessibleName={toolTipContent}/>
            </div>
        </div>);
}
const styles = {
    container: css({
        width: "100%",
    }),
};
